import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Validator from '@/utils/Validator'

export default {
  name: 'SelectVideoChatModal',
  components: {
    Loading
  },
  data () {
    return {
      loading: true,

      // テーブルオプション
      tableColumns: [
        'type',
        'serviceId',
        'userType',
        'userId',
        'userName'
      ],
      tableData: [],
      tableOptions: {
        headings: {
          type: '種別',
          serviceId: "サービスUUID",
          userType: 'ユーザ種別',
          userId: 'ユーザUUID',
          userName:'ユーザ名'
        },
        columnsClasses: {
          type: 'wp-5',
          serviceId: 'wp-35',
          userType:'wp-5',
          userId:'wp-35',
          userName:'wp-20'
        },
        sortable: [],
        filterable: [],
        texts: Constants.TableOptions.getTexts('データ'),
        perPage: Constants.TableOptions.perPage.modal,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial,
      isSearch:0
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      // model
      extraInfoModel: state => state.selectVideoChatModal.extraInfoModel,
      // 検索
      filters: state => state.selectVideoChatModal.filters,
      active: state => state.selectVideoChatModal.active,
      overlay: state => state.selectVideoChatModal.overlay
    }),
    ...mapGetters({
      isSmartPhone: 'core/isSmartPhone'
    }),

    // list
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    modeList () {
      return [
        {
          value: 1,
          label: 'ロケーションID'
        },
        {
          value: 2,
          label: '管理CMSアカウント'
        }
      ]
    },
    showFilters () {
      return !this.isSmartPhone ||
          this.activeFilters
    },
    disableDetermineButton () {
      if (this.tableData.length === 0) return true
    },
    disableSearchButton(){
      if(this.searchKeyWord === null || this.searchKeyWord === "") return true
    },
    // filter
    searchKeyWord: {
      get () {
        return this.filters.searchKeyWord
      },
      set (value) {
        this.setInputFilter({
          key: 'searchKeyWord',
          value: value
        })
      }
    },
    filterMode: {
      get () {
        return this.filters.filterMode
      },
      set (value) {
        this.setInputFilter({
          key: 'filterMode',
          value: value
        })
      }
    },
  },
  watch: {
    '$route' () {
      // ルーティング変更時にコンポーネントを非表示
      this.hide()
    },
    active (to) {
      if (!to) {
        this.hide()
      }
    },
    filterMode (to) {
      this.filterMode = to
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      loadModel: 'selectVideoChatModal/loadModel',
      loadVideoChatList: 'selectVideoChatModal/loadVideoChatList',
      hide: 'selectVideoChatModal/hide',
      setValue: 'selectVideoChatModal/setValue',
      reset: 'selectVideoChatModal/reset'
    }),
    ...mapMutations({
      setInputFilter: 'selectVideoChatModal/setInputFilter',
      setInputValue: 'serviceScreenSettingForm/setInputValue',
    }),

    init () {
      this.loading = false
      // storeをリセット
      this.reset()
      this.filterMode = 1
    },
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },

    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },
    determineValue () {
      let extraInfoModelData = [];
      extraInfoModelData = [
        { k: 'type', value: this.extraInfoModel[0]['type'], dataType: 'string' },
        { k: 'serviceId', value: this.extraInfoModel[0]['serviceId'], dataType: 'string' },
        { k: 'userType', value: this.extraInfoModel[0]['userType'].toString(), dataType: 'integer' },
        { k: 'userId', value: this.extraInfoModel[0]['userId'], dataType: 'string' },
        { k: 'userName', value: this.extraInfoModel[0]['userName'], dataType: 'string' },
        { k: null, value: null, dataType: null },
        { k: null, value: null, dataType: null },
        { k: null, value: null, dataType: null },
        { k: null, value: null, dataType: null },
        { k: null, value: null, dataType: null },
      ]
      this.setValue(extraInfoModelData)
      this.closeModal()
    },
    search () {
      this.loading = true
      let searchParams = { filters: {} }
      searchParams.filters.target = this.filterMode
      searchParams.filters.keyword = this.searchKeyWord

      // データ読出し
      // this.loadVideoChatList({
      this.loadModel({
        searchParams: searchParams
      })
          // eslint-disable-next-line
          .then(res => {
            this.loading = false
            this.filterMode = this.filters.filterMode
            this.isSearch = 1
            this.tableData = $.extend(true, [], this.extraInfoModel)
          })
          .catch(error => {
            this.loading = false
            this.isSearch = 0
            this.tableData = $.extend(true, [])
            this.showError(error || null)
          })
    },

    selectItem (props) {
      // console.log(props.row)

      // 選択されたファイル情報をstoreに保持
      this.setValue(props.row)

      this.closeModal()
    },

    /**
     * モーダルを閉じる
     */
    closeModal () {
      this.hide()
    }
  }
}
